import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import * as func from '../../../utils/funcs';
import styles from './SignupQuickForm.module.css';
import { useGetAppLinks } from '../../../hooks/useGetAppLinks';
import { DevOnlyFormFiller } from '../../../DevTools/DevOnlyFormFiller';
import SignInHeader from '../../SignInHeader/SignInHeader';
import PrimaryButton from '../../../partials/PrimaryButton';
import { registerOtp } from '../../../api/newAuthApi';
import { getCities } from '../../../api/getCities';
import { getUserPlayerInfo } from '../../../api/getUserPlayerInfo';

function SignupQuickForm(props) {

  const { user, setUser, stage, setIsFixedCss, invited } = props;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const telParam = queryParams.get('tel') || '';

  const history = useHistory();

  const { signIn } = useGetAppLinks();

  const [cities, setCities] = React.useState([]);
  const [textError, setTextError] = React.useState('');
  const [invalidToken, setInvalidToken] = React.useState(false);

  const [fName, setFName] = React.useState('');
  const [lName, setLName] = React.useState('');
  const [phone] = React.useState(telParam);
  const [city, setCity] = React.useState('');
  const [school, setSchool] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [shirtSize, setShirtSize] = React.useState('');
  const [wantCaptain, setWantCaptain] = React.useState(false);
  const [terms, setTerms] = React.useState(false);


  React.useEffect(() => {
    let mounted = true;
    getCities().then(data => {
      if (!data.error && mounted) {
        setCities(data);
      }
    });
    return () => { mounted = false; };
  }, []);

  const badWord = word => word.length < 2;
  const didNotPick = check => check === '';

  const handleCreateUser = async () => {
    setTextError('');


    const tempToken = sessionStorage.getItem('otp_temp_token');
    if (!tempToken) {
      setInvalidToken(true);
      return;
    }

    if (badWord(fName)) {
      setTextError('שם פרטי אינו תקין');
    } else if (badWord(lName)) {
      setTextError('שם משפחה אינו תקין');
    } else if (didNotPick(city)) {
      setTextError('לא בחרת עיר');
    } else if (didNotPick(grade)) {
      setTextError('לא בחרת כיתה');
    } else if (didNotPick(shirtSize)) {
      setTextError('לא בחרת מידת חולצה')}
      else if (!terms) {
        setTextError('עליך לאשר את תקנון השימוש');
      }
     else {
      const res = await registerOtp({
        firstName: fName,
        lastName: lName,
        city,
        grade,
        shirtSize,
        wantCaptain,
      }, tempToken);

      if (res.error === 'invalid_temp_token') {
        sessionStorage.removeItem('otp_temp_token');
        setInvalidToken(true);
        return;
      }

      if (res.error) {
        setTextError(res.message);
        return;
      }

      // Success — token stored in cookie by registerOtp
      const userData = await getUserPlayerInfo();
      setUser(userData);
      sessionStorage.removeItem('otp_temp_token');
      
      // If user came from invite link, redirect to join page
      if (invited) {
        history.push('/redirect');
      }
    }
  };


  const handleFocus = answer => {
    if (!func.deviceIsIphone()) {
      setIsFixedCss(answer);
    }
  };
  const handleClickTerm = () => {
    history.push('/signup/term');
  };
  // Invalid/expired temp token — show error and back link
  if (invalidToken) {
    return (<div className={styles.signupForm}>
        <p>תוקף ההרשמה פג, יש לחזור לדף הכניסה</p>
        <Link to="/signin-sms">חזרה לדף הכניסה</Link>
      </div>);
  }

  return (<div
    className={`${styles.signupForm} `}
  >

    <DevOnlyFormFiller setFormData={() => {
      setFName('דוד');
      setLName('כהן');
      setCity('1');
      setGrade('10');
      setSchool('דרור');
      setShirtSize('M');
    }}>


      <form className={styles.signupFormSection}>
        <SignInHeader phone={''}>
          יצירת משתמש חדש עם המספר
          &nbsp;
          {phone}
        </SignInHeader>
        <input
          type="text"
          value={fName}
          onChange={e => setFName(e.target.value)}
          placeholder="שם פרטי"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />
        <input
          type="text"
          value={lName}
          onChange={e => setLName(e.target.value)}
          placeholder="שם משפחה"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />
        <select
          name="city"
          value={city}
          onChange={e => setCity(e.target.value)}
          required={true}
        >
          <option value="" hidden>
            עיר
          </option>
          {cities.map(city => {
            return (<option key={city.id} value={city.id}>
              {city.name}
            </option>);
          })}
        </select>

        <select
          name="grade"
          value={grade}
          onChange={e => setGrade(e.target.value)}
          required={true}
        >
          <option value="" hidden>
            כיתה
          </option>
          <option value={4}>ד'</option>
          <option value={5}>ה'</option>
          <option value={6}>ו'</option>
          <option value={7}>ז'</option>
          <option value={8}>ח'</option>
          <option value={9}>ט'</option>
          <option value={10}>י'</option>
          <option value={11}>יא'</option>
          <option value={12}>יב'</option>
          <option value={13}>בוגרים</option>
        </select>


        <select
          name="shirtSize"
          value={shirtSize}
          onChange={e => setShirtSize(e.target.value)}
          required={true}
        >
          <option value="" hidden>
            מידת חולצה
          </option>
          <option value="S">S</option>
          <option value="M">M</option>
          <option value="L">L</option>
          <option value="XL">XL</option>
          <option value="XXL">XXL</option>
        </select>


        <span className={styles.errorMsg}>{textError}</span>
        <div className={styles.checkBoxContainer}>


        <span className={styles.termCheck}>
          <input
            type="checkbox"
            id="wantCaptain"
            name="wantCaptain"
            checked={wantCaptain}
            onChange={() => setWantCaptain(s => !s)}
          />
          <label htmlFor="wantCaptain">
            אני רוצה להיות קפטן
          </label>

        </span>

        <span className={styles.termCheck}>
          <input
            type="checkbox"
            id="termAgree"
            name="termAgree"
            checked={terms}
            onChange={() => setTerms(s => !s)}
          />
          <label htmlFor="termAgree">
<span style={{margin :0, padding:0, textDecoration: 'none'}}>
            מאשר את</span>
            &nbsp;
            <span onClick={handleClickTerm} style={{margin :0, padding:0 }}>
            תקנון השימוש</span>
          </label>
        </span>
        </div>
        <PrimaryButton
          size={'large'}
          className={`btnLarge ${styles.marginTop}`}
          onClick={handleCreateUser}
          text={'רשום אותי לליגה!'}
        >

        </PrimaryButton>
      </form>
    </DevOnlyFormFiller>
  </div>);
}

export default SignupQuickForm;



